import { render } from "./UserPhoto.vue?vue&type=template&id=9894e996"
import script from "./UserPhoto.vue?vue&type=script&lang=js"
export * from "./UserPhoto.vue?vue&type=script&lang=js"

import "./UserPhoto.vue?vue&type=style&index=0&id=9894e996&lang=scss"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__